import request from '@/utils/request';
export function methodList() {
  return request.post('admin/payment-method/list', {
    page: 1,
    pageSize: 100
  });
}
export function methodStatus(data) {
  return request.post('admin/payment-method/status', data);
}
export function methodPriority(data) {
  data.priority = 1;
  return request.post('admin/payment-method/priority', data);
}
export function methodMove(data) {
  return request.post('admin/payment-method/move', data);
}
export function methodList2(data) {
  return request.post('admin/payment-merchant/lists', data);
}